import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewEncapsulation
} from "@angular/core";
import {ActivatedRoute} from "@angular/router";
import {Store} from "@ngrx/store";
import {forkJoin, noop, Observable, of, Subject} from "rxjs";
import {CommentItem, CommentService, EVENTS} from "@uxf/vnc-library";
import {ChannelService} from "../channel.service";
import {CommentBulkAdd, CommentRepliesLoadSuccess, CommentUpdate} from "../store/actions/comment";
import {ChannelRootState, getAllComments, getParentCommentInTopicById} from "../store/reducers";
import {AvatarRepository} from "app/talk/repositories/avatar.repository";
import {ChannelRepository} from "../repository/channel.repository";
import {catchError, debounceTime, distinctUntilChanged, filter, map, take, takeUntil} from "rxjs/operators";
import {Topic} from "../models/topic.model";
import {CommonUtil} from "../../talk/utils/common.util";
import {TranslateService} from "@ngx-translate/core";
import {TOPIC_COMMENTS_LOADED} from "../topic-detail/topic-detail.component";
import {Broadcaster} from "../../talk/shared/providers";
import {ContactRepository} from "../../talk/repositories/contact.repository";
import {ChannelSnackbarService} from "../channel-snackbar.service";
import {SnackbarType} from "../models/snackbar.model";
import {DEFAULT_AVATAR, DEFAULT_IMG} from "../../common";
import {ConversationRepository} from "../../talk/repositories/conversation.repository";
import {Member} from "../models/member.model";
import {FileActionsService} from "../../talk/services/file-actions.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {File} from "../models/file.model";
import {Channel} from "../models/channel.model";
import {MatDialog} from "@angular/material/dialog";

import {TopicCommentsLoadSuccess} from "../store/actions/topic";
import {BreakpointObserver, BreakpointState} from "@angular/cdk/layout";
import {ConstantsUtil} from "../../talk/utils/constants.util";
import {CommonService} from "../../shared/providers";

import { DatetimeService } from "app/talk/services/datetime.service";
import format from "date-fns/format";
import enUS from "date-fns/locale/en-US";
import de from "date-fns/locale/de";
import { DatePipe } from "@angular/common";

const MAX_FILES_UPLOAD_SIZE_IN_MB = 100;
export const MESSAGE_DECODER_SECRET_KEY = `<span class="hidden-secret-key">_._{{ USERNAME }}</span>`;
export const TOPIC_MENTION_MESSAGE_RECEIVER = "You are mentioned in a comment of this topic:";
export const TOPIC_MENTION_MESSAGE_SENDER = "You've mentioned {{ USERNAME }} in a comment of this topic:";
import { getAppSettings } from "app/reducers";
import { AppSettings } from "app/talk/models/app-settings.model";

@Component({
  selector: "vp-comments",
  templateUrl: "./comments.component.html",
  styleUrls: ["./comments.component.scss"],
  encapsulation: ViewEncapsulation.None
})
export class CommentsComponent implements OnInit, OnChanges {
  private isAlive$ = new Subject<boolean>();
  comments: any[] = [];
  sortedComments: any[] = [];

  commentLabelTranslations = {
    REPLY_LBL: "Reply",
    REPLIES: "Replies",
    EDIT_COMMENT: "Edit comment",
    ADD_COMMENT: "Add comment",
    DELETE_COMMENT: "Delete comment",
    NEW_COMMENT: "New comment",
    COMMENTS: "Comments",
    AUTHOR: "Author",
    CANCEL: "Cancel",
    SEND: "Send",
    SEE_MORE: "See more",
    READ_MORE: "Read more",
    LIKE: "Like",
    LIKES: "Likes",
    COMMENT: "Testing",
    ATTACHMENT: "Attachment",
    ATTACHMENTS: "Attachments",
    FILE: "File",
    FILES: "Files",
    UPLOADING: "Uploading...",
    SHOW: "Show",
    HIDE: "Hide",
    SHOW_OTHER_REPLIES: "Show other replies",
    ATTACH_FILE: "Attach file",
    YOUR_COMMENT: "Your comment"
  };

  @Input()
  topicId: any;
  topic: Topic;

  @Input()
  focusOnCreation = false;

  @Input()
  comment_count: number = 0;

  @Input() isHideTextEditor = false;

  @Input() isMobile = false;

  @Input() isSocial = false;

  @Output() onFormClear = new Subject();
  @Output() enableDisableComments = new EventEmitter();
  language: string = "english";
  avatarUrl: any;
  usersForMentions: { id: string; value: string, avatar_url: string, type: "user"|"tag"}[] = [];
  jid: string = "";
  isUploadRunning = false;
  inlineUploads = [];
  uploadedFiles: any[] = [];
  uploadFilesCount = 0;
  fileUploading = false;
  defaultAvatar = DEFAULT_AVATAR;
  mentionedCommentId: number;
  level1_offset: number;
  lang = "en";
  level1_total_count: number;
  childOffsets: { [commentId: number]: { offset?: number, total_count?: number } };
  isMobileScreen: boolean = false;
  tagsForMention: { id: string; value: string }[] = [];
  defaultTagsForMention: { id: string; value: string }[] = [];
  channelsForMentions: { id: string; topics_count: number; author_name: string; value: string, avatar_url: string, type: "channel"}[] = [];
  defaultChannelsForMentions: { id: string; topics_count: number; author_name: string; value: string, avatar_url: string, type: "channel"}[] = [];
  topicsForMentions: { id: string; channel_name: string; author_name: string; value: string, avatar_url: string, type: "topic"}[] = [];
  defaultTopicsForMentions: { id: string; channel_name: string, author_name: string, value: string, avatar_url: string, type: "topic"}[] = [];
  settings: AppSettings;
  cancelFileUploadVar = false;

  constructor(
    private store: Store<ChannelRootState>,
    private route: ActivatedRoute,
    private commentService: CommentService,
    private channelRepository: ChannelRepository,
    private contactRepository: ContactRepository,
    private broadcaster: Broadcaster,
    private channelService: ChannelService,
    private avatarRepo: AvatarRepository,
    private translate: TranslateService,
    private commonService: CommonService,
    private datetimeService: DatetimeService,
    private channelSnackBarService: ChannelSnackbarService,
    private conversationRepo: ConversationRepository,
    private snackBar: MatSnackBar,
    private fileActionsService: FileActionsService,
    private changeDetectorRef: ChangeDetectorRef,
    private matDialog: MatDialog,
    private breakpointObserver: BreakpointObserver,
    private elementRef: ElementRef,
    private datePipe: DatePipe,
    ) {
    this.commonService.currentLanguage.pipe(takeUntil(this.isAlive$), map((lang: string) => {
      switch (lang) {
        case "en": return "english"; case "de": return "german";
      }
    })).subscribe((translatedLanguage: string) => { this.language = translatedLanguage; });
    this.isMobileScreen = this.breakpointObserver.isMatched("(max-width: 767px)");
    this.breakpointObserver
      .observe(["(max-width: 767px)"])
      .pipe(takeUntil(this.isAlive$))
      .subscribe((state: BreakpointState) => {
        if (state.matches) {
          this.isMobileScreen = true;
        } else {
          this.isMobileScreen = false;
        }
        this.changeDetectorRef.markForCheck();
    });
    this.route.queryParams.pipe(filter(value => value.hasOwnProperty("commentId"))).pipe(takeUntil(this.isAlive$)).subscribe((queryParams: {commentId: number}) => {
      const commentId = queryParams["commentId"];
      if (!this.isHideTextEditor) {
        this.mentionedCommentId = commentId;
      }
      this.mentionedCommentId = commentId;
    });
    this.store.select(getAppSettings).pipe(takeUntil(this.isAlive$)).subscribe(options => {
      this.settings = options;
      this.updateSortedCommentsDate();
      this.changeDetectorRef.markForCheck();
    });
  }

  updateSortedCommentsDate() {
    if (this.sortedComments && this.sortedComments.length > 0) {
      this.sortedComments = this.sortedComments.map(c => {
        if (c) {
          const updatedComment = { ...c, created_on: this.getPublishDate("post", c.created_on) };
          if (c.replies && c.replies.length > 0) {
            updatedComment.replies = this.updateCommentsDate(c.replies); // Recursively update replies
          }
          return updatedComment;
        }
      });
    }
  }

  // A recursive function to update the date format in comments and their replies
  updateCommentsDate(comments: any[]) {
    return comments.map(comment => {
      const updatedComment = { ...comment, created_on: this.getPublishDate("post", comment.created_on) };
      if (comment.replies && comment.replies.length > 0) {
        updatedComment.replies = this.updateCommentsDate(comment.replies); // Recursively update replies
      }
      return updatedComment;
    });
  }


  ngOnInit(): void {
    if (this.channelRepository?.userJID?.bare){
      this.jid = this.channelRepository.userJID.bare;
    }
    this.buildAvatarUrl(this.jid);
    this.commonService.currentLanguage.pipe(takeUntil(this.isAlive$)).subscribe((lang: string) => {
      this.lang = lang;
    });
    this.conversationRepo
      .getTags()
      .pipe(take(1))
      .subscribe((tags) => {
        this.tagsForMention = tags.map(v => ({id: v.id, value: v.name, type: "tag"}));
        this.defaultTagsForMention = [...this.tagsForMention];
      });
      this.channelService.getChannels().subscribe(res => {
        const channels: Channel[] = res.channels;
        this.channelsForMentions = channels.map(v => ({id: v.id, topics_count: v?.topics_count, author_name: v?.author?.name, value: v.name, type: "channel", avatar_url: v.avatar_url}));
        this.defaultChannelsForMentions = [...this.channelsForMentions];
      });
      this.channelService.getAllTopics().subscribe(res => {
       if (!!res){
        const topics: Topic[] = res.topics;
        this.topicsForMentions = topics.map(v => ({
          id          : v.is_iom ? "iom-" + v.id : v.id,
          channel_name: v?.channel_name,
          author_name : v?.author?.name,
          value       : v.subject,
          type        : "topic",
          avatar_url  : CommonUtil.getTopicAvatar(v),
        }));
        this.defaultTopicsForMentions = [...this.topicsForMentions];
       }
      });
    this.commentService.updateConfig({rtfModules: {
      syntax: false,
      toolbar: [
        ["bold", "italic", "underline", "strike"],        // toggled buttons
        ["code-block"],
        ["blockquote"],
        ["link", "image", "video"],                         // link and image, video
        ["emoji"]
      ],

        mention: {
          allowedChars: /^(\u00a9|\u00ae|[\u2000-\u3300]|\ud83c[\ud000-\udfff]|[a-zA-Z0-9!@#\$%\^\&*)(+=._-]|\ud83d[\ud000-\udfff]|\ud83e[\ud000-\udfff])*$/,
          mentionDenotationChars: ["@channel", "@topic", "@", "#"],
          source: async (searchTerm, renderList, mentionChar) => {
            const matchedOptions = await this.suggestMentionOptions(searchTerm, mentionChar);
            renderList(matchedOptions);
          },
          renderItem: (item: { id: string; value: string; topics_count: number, channel_name: string, author_name: string, avatar_url: string, type: "user"|"tag" | "channel" | "topic" }) => {
            if (item.type === "user") {
              const imageUrl = !!item.avatar_url ? item.avatar_url : DEFAULT_AVATAR ;
              return `<img src= ${imageUrl} onerror="this.onerror=null;this.src='data:image/png;base64,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';">
            <span> ${item.value} </span>`;
            } else if (item.type === "channel") {
              const imageUrl = !!item.avatar_url ? item.avatar_url : DEFAULT_IMG ;
              return `<div class="mention-list-item"><img src= ${imageUrl} onerror="this.onerror=null;this.src='data:image/png;base64,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';">
            <div class="mention-wrap"><span class="mention-head channel-head"><span>${HASH_TAG} ${item.value}</span></span><div class="mention-specs topic-title"><p>${TOPIC_PHOTO_ICON} ${item?.topics_count} Topics</p><p>${PROFILE_ICON} ${item?.author_name}</p></div></div></div>`;
            } else if (item.type === "topic") {
              const imageUrl = !!item.avatar_url ? item.avatar_url : DEFAULT_IMG ;
              return `<div class="mention-list-item"><img src= ${imageUrl} onerror="this.onerror=null;this.src='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAUAAAAFABAMAAAA/vriZAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAnUExURbjauisRDltVSUo+NHB0YzQeGbHQsY6fhz8tJqfCppuxl4CKdmZlVsh7iZYAAA60SURBVHjazZ29bx1ZFcCfbMuWP5qJ17JFUtgWLBTbGIShtCESSGxjKJZkG8tuXNpAtAU0q4VISRUJWbKo3LhANDYNbUwK/i1m3nvz3szcr9+558wks80qmczH793zfebc0R9/Ao+fjQyPX/K7bhTw2Lq0e74letPi/Wj0SM99afeAx/Sez8qTS4Tff54+viyKWzuAW+COz38xBlghfMHe+qUdQHSp6zHACuHOO/bat2YAyZVWv50ArBC+GRQhvNDNFOBotDAswnUMcLf+/71BET5QgE9m/z8ownWmUZsAMcJHC4QPxbYUIEZYyvvtQACXWwBHy3vFa4bwxUcBOBqdFTunCOHWOy3AIgPgGOEhQ/hG94BXDOB58eS0+ycQ4Y4K4QoEeODyOmAI93QIr4qnDODmKfkzz7GgQlgCvM8E6P9Da4QKgIMg1AAcBKEKIEZ4lo1w5UQDUILwMO8B73QAfdoxhPA05/nWToojcl6Yk2NfRirSLsDPyGmLkfe/KDbZJTZPewMY9VtW+0QIAcbVWNfJES9j/QqMa7EeEZoA7BHh6kkd5OrMQG8I72ZBrtKQ9oTQCmAz35BC+LnkAW8YQOIPw0v9nVkd2WujoAz+GNDqyBYOi8muGcILdk+J6MGodo0hXBUg5ABRXuCaqdQbjJC+C01OQaPEEcJX4bmpO1uEy8YAzRFeWAMUICTyTs2iJD3KEQJ5h1ZRlh2FCInKpAAfRMlRGCASqwMBrgvTy69YhJhGyAF+r48YO211OMDLXrIUqcXKAW7Lno/meVLyjgEWQoBWCHsDaIRwkWVJcgBWCL/WIqTVjasMgDjfvRaRd5jsXMkCiN8rklSDuc48gHhlhFUmB3if9YBUtoJWBwN8mvd8GGGAQO8AK4RfKRA89g0QW0g/A1g1g1a/B4SwdPtKARB7aT5FBiu3ayqA2E3zaDLYPnCnAogjBRch/Ic0MayOtRyVeUwBfqZ7PkqiqzIHA5iLcDCAmQgHBChA+JU4yLUAiLN2TatD28dgZj11QJPQoAa1J8zlEoTvRIuVto8ZAZT3kOLuJxuA4h5S6EbS0gQ5ZA2Qme1jmkPUAMkB7po9oAjh1fAARQhXPgZAQQ/pWxhi2AIU9JBusRhNAPBPpKv++ZcnxV/JeSdFsUnO+3VRoPs+/9XovPikj8MqB/oJH1X6s0T4Hfg05ufktJ9WF/3O5lrj06r0J0wjo9PKGI3IO0wM16cJT094yEDepUhggwS47NhDTiOEROYtYhdGrSiTECOJkAKc9ylateVNQ4wUQt7peSq0O4kr1zFaogEyp1cWN0RtHYIYLZHbX8zpNsYII9088xDjLPYI9KuB9kKhCGOnzWO06I8IO2C7ogYRRuS9GaPFfkVY2+lKGu0pCyNsxmgRhNBvc0+DMWCQdPsNw/KOPd83eVF0cLG2nzyIkDu+7zLzEAGE3QcPIcQAX+QmIgIIu88dQKgAqGuIch/bj1D1/Z6mm8dVP14XSfkdbn5DlO9396lM5We4FKG7WH0P41GZ4jxeJkJH3v0er7tY1Z+Cr2U2RPkFwvndYS45loB/ldWKEtLKXYQwGx87jTdEHQGl3EGI6xmx03K6ecKeQRshLmfETsvp5gk7Bi2ES/Jqhg3CmHfaVJm5VUk1wphz2rA6RgDl3TzxGG2uMh9sAOI2pZm8x0OMmcpcZ5NCSAJeiDARYtQf4uDujG2Tl5gv1pSDN12svL/l0mIZNOQ96eBN5B1fc9toHdQI0x7yGKGqQciHEHfzAA+5Qij6USx0Uf2+/wYeconwN7omNak5bLxwQTzku/I0U4BYaZVvTEKMEqGyUVLmkjWOA/bKxyzvI+kyY4azmth1iUATNLIuM4TwsTghi6taqk/JUpV0mRGE5Tn/AghLgP8BCKU9PgBhdQpQmZVsAvmU9vikEY7PSKvMsWymNZy8SSrZnzhhnFSZk6WVRChvkkplAaaIUypzKpspNyWnyyyRBqgXaWKx1mQSfkpOl1k8EzWLXuOLdUYm7iLlNUlFPZX52osinJOJIszrMov5eg3pjSFsLK0YwtwuswjCpoMXQdhcWhGfMLfLLIywpf7CCFuyGVaZ+V1mQYRtGkGV2Z6tELQ6+T0+odk8nfUUmgjXWVohhJomqUBhsiuRAZXZlc2A1dE0SfnTBo5Z8FsdRzaXvFZH1WXmT7y4htWbvXdl0yvvui4zX+rK45r4rI5HNn3yvqxr0/Mh9HkmHnn3kfEgvFC26bnpU69v56pM79JyEUqHmgCEftfOQehfWg7C86z5TrErBKLXLsKAbHYR5k7IilwiFHx1EIZks2N19AC7rSjB6LVtdYKy2VaZBgC7yzjs+rasTlg2W1bHAmD7ZpHYoWl1SoCfg1jHBGB7vUdih+bdYmQaVscGYBNhNPiaW50omYa82wBsIowGX/PHipOZybsVwLnOSMQO9Q0TS6tGSD+AFyBMTB+rHyxFZopwIXPOYhhhMviaPFlSNqcI97RTex3XKRl8TR4tubSWx4+2oBza6zqfIPiqng0ot7HKtAQ4mYoCXN/K6hDZPChe2wIcB0DE9b0oNolsLlanWQKc1BKA61vaOCSbB4UxwHE5hsQOF6i2UyI0Bji+8xFKl6D32CiMrFzrtyM5xj20EqotR6zM3Hz1kyxtKZtElkqf68AWYaU/SJq2lE0SiJeO/7ktwupyoFZVKTeQyqhCp2VThJOrpat9Y2c0nY4cB5/nxe9OTQGCct8kA5I0iZPYUx2ye/yoVDlmGhClUuLT6P3C7tvEekEnKlp1PJRwy+rgfdns6875eo4jfCzezgx3GqAhwrlGiCKcd4BGJ8LNGxjNPpBtKITYLK5GYiimMhsTBIy+kG1OH4sUBZt5oUh42kyl2yBsB1/hckwrsxZG2LqACcK26xtE2E6sBRG2KxgmgwI6rm8IYSc1GULY+ecGoxa6sUOgKNjNTAasTvdfGwyrcGIHf0XLKdL4E51OUVY97sMNvrwVLbc725sqdlewGqEn+PJVtDxYfb6Pp6qtROir0HjKMb6F6bE6PkOkHNrjLRO65RjvunQNt9eUq6b2+KuEDkK/ZDu8/JZchTBQqu4iDOjGLrCAL6RAGCr2d/48ZF06fx5qYFQgDLZLtP8i2HHS/otgSJONMNwt0fr4J+zhtNZmOKLJHqAX6TdpSnfEzW4uzginzBGEsY6dhnjHvOwGwthKyxziGO15miOMxilzhNGFljUGM/7x08zExCO9GcK4qGYNEk1MH6uNdOLlaxuTkNQMhKnmz6mbk5LA6WVSui4DYfL7gAnCpABOfJ/kBjRwdHPSce4iTKuwsS5Ie33igcrgA4sKITAClTIATp9wojL56OWs2PkHMKMlwn8Ct1k41Ju8Txkw/41Y0ePi98RrFo1FZyvirECZ/6WiIHGHCCFbEMsHLJ54ZPkD+KWSQCuVIkwS4avf5o1y1ev16wKVY27K096aIoQAS+X2ASAsAX7BPr7HG2xggM9ILaHKo+I5pGj4KN2bpMpMpcsx4xyg7Ubsd3SA4DPSOzRJRFvuZb92IhkgmNpJc1oNsdxFXDaTpHyA3dhp9Rqw24hdukdTPIs7WwJ2CKVDXeLlmLkQWSGUb3IVQ9iQIT4K59YCYKNIFKslNLWQYphQGyBwPNq/axhhSwnZbMSes9tfGGFLjZvsZU/3S2yXekO1hI4WP2NNAFGrAwF2DFyoHNP5UWkTQGTuEN+z85C8V/c3XVTvIp47J9G/MhypUO8inr9vrDcud++j3Yg9f9Dkqke9e26jRKjZeNej33130SHUTOp0LaT3JnzA6WtbgB6E/p8Jj4j1WB3YgxHYnqyLMKBu6dBcD8KU51kfBwGD1UEY0rb56yhjvGwkUgiafNrN4ywktRJtpzLDFj8X4bnaDDWj1dDXnvmyqAfYivdjIwbyEOoBNjMm0dAnC6EFwAbCeOSTg9AC4BxhInbMQGjgSk4RbpPQ8Ya6xbOkhU08U2eOk8G3fO6wRTgzzZ9tk4lJ0tDMCuAkiwvSkNK97FXjZR2EJJF7J5o7vFAU+/v/Tf63XxQ//mI/8d+Pqq0Xkqftf2C3/DD5cmHvU9684skY4Kd87I7+sI+Ok+K37LRih5z3g2KL3feHI3bwTeGG3AhOlpudSvHxkDvBNcjgvR35Xnr3hg+I5+ltY9ivlPthdgFeMoD3fCdNS4SyHVqHRyjcJngDL9h7M4CyCYyw8HVlhVC8VTWcfW6G8EG82fcAWys7frJIsW30uz26P9IQmYae90fPWSlt4woLX+sWCK+yJs0PhzAL4JAI8wBihA9ahJkAcagIrbzaYHrCtAMWbAsaohRemy/Q5QhvFQ94h3t8kilIpaupihz8mQJYO1xio5tVgYM/XUURHucjlHdYhFOQ6oBRBfBJMgXZC0IlwP4RKgH2jlANMN16pkN4rdx/bcQLX485CFdPtDvYjXAJFQYxWQDjj7CKEb4QA8xsUREsAB3Cm6weHwXCN2KAuwYAMULxjKYbo+1kMULhkCYzgHitCBGaAeSTAEQIDQFifSVCaAiQa3wBwuzWDBXCMz7uDxoo2FKJSw4HdGCiqsNK4bctUoS8QQD+JBzhoSFAiV7ACK32a5eqBYiQoekBIEaI2PQAEKdQCJxeAOIkFKBzbtAv7jlWzBAa9fg4xxVFmIgDccO91EWHmdBUD+myWY9PLsKEmV3APT7iSBtWbRKent3HWz6E22qEC6ZfEPaAsE+AuOQQ8ZZ7BYirNhGE/QLUI9zoF6AE4XuNdVDUDWDVJhBKbxh/R53/bwNxIP6MWlG7gt9ge+NADvAy/wF539R7D8CXhpKo1AAehEvmwxCUCI/yXk1dgM7t3hsIYD7CY0H/3cdAuMQbGLUPuJGFEAM06GWC+raFcH3IhjqocFuhNFTwRs1gEGEjlDbeg9sopm6E0g/WW0jbZCVm91u330LaJK8z+8XkDYzDIiwB/u+b9PFnw7biEiG44zd/mSC8oh8mGPa2409Evp7swc2OI7sHPMM3vfwoAKscEDy2/w9mYKj88p949wAAAABJRU5ErkJggg==';">
            <div class="mention-wrap"><span class="mention-head"><span>${TOPIC_PHOTO_ICON} ${item.value}</span></span><div class="mention-specs"><p>${HASH_TAG} ${item?.channel_name}</p><p>${PROFILE_ICON} ${item?.author_name}</p></div></div></div>`;
            } else {
              return `<span> #${item.value} </span>`;
            }
          }
        },
        "emoji-toolbar": true,
        "emoji-shortname": true,
      }});
    this.handleCommentFileActions();
    this.commentService.on<any>(EVENTS.ADD_COMMENT).pipe(takeUntil(this.isAlive$)).subscribe(v => {
      this.addComment(v.comment, v.attachments, v.parentId);
    });
    this.commentService.on<any>(EVENTS.DELETE_COMMENT).pipe(takeUntil(this.isAlive$)).subscribe(v => {
      this.deleteComment(v.comment.id, v.parent ? v.parent.id : null);
    });
    this.commentService.on<any>(EVENTS.EDIT_COMMENT).pipe(takeUntil(this.isAlive$)).subscribe(v => {
      this.updateComment(v.id, v.comment, v.attachments, v.parentId);
    });
    this.commentService.on<any>(EVENTS.UPLOAD_COMMENT_FILES).pipe(takeUntil(this.isAlive$)).subscribe(value => {
      this.onFileUpload(value.fileEvent, true);
    });
    this.commentService.on<any>(EVENTS.UPLOAD_INLINE_IMAGE).pipe(takeUntil(this.isAlive$)).subscribe(value => {
      this.onInlineFileUpload(value.fileEvent, value.commentId);
    });
    this.commentService.on<any>(EVENTS.FORWARD_COMMENT).pipe(takeUntil(this.isAlive$)).subscribe(() => {
      this.forwardMobileComment();
    });
    this.commentService.on<any>(EVENTS.REPLY_IN_COMMENT).pipe(takeUntil(this.isAlive$)).subscribe(v => {
      const isDialogOpen = document.querySelector("vp-channel-add-edit-comment");
      if (isDialogOpen === null) {
        this.replyMobileComment(v);
      }
    });

    this.commentService.on<any>(EVENTS.EDIT_ON_COMMENT).pipe(takeUntil(this.isAlive$)).subscribe(v => {
      const isDialogOpen = document.querySelector("vp-channel-add-edit-comment");
      if (isDialogOpen === null) {
        this.editMobileComment(v);
      }
    });

    this.channelRepository.getSelectedTopic().pipe(takeUntil(this.isAlive$))
      .subscribe(v => {
        if (!!v && !!v.id) {
          this.topic = v;
          this.getMentionUsers(v);
        }
        this.changeDetectorRef.markForCheck();
      });
    this.commentService.on<any>(EVENTS.LIKE_COMMENT).pipe(takeUntil(this.isAlive$)).pipe(debounceTime(200), distinctUntilChanged( )).subscribe(v => {
      this.likeComment(v.id, v.liked);
    });

    if (!this.mentionedCommentId) {
      this.commentService.on<any>(EVENTS.LOAD_REPLIES_COMMENT).pipe(takeUntil(this.isAlive$)).pipe(distinctUntilChanged()).subscribe(v => {
        this.loadRepliesComment(v.comment, v.parent ? v.parent : null);
      });

      this.commentService.on<any>(EVENTS.LOAD_MORE_REPLIES).pipe(takeUntil(this.isAlive$)).pipe(distinctUntilChanged()).subscribe(v => {
        this.loadMoreReplies(v.comment, v.parent ? v.parent : null);
      });

      this.broadcaster.on<any>("ADD_COMMENT_IN_TOPIC_ITEM").pipe(takeUntil(this.isAlive$)).subscribe(() => {
          this.addMobileComment();
      });

      this.broadcaster.on<any>(ConstantsUtil.ADD_COMMENT_IN_MENTIONED_COMMENT).pipe(takeUntil(this.isAlive$)).subscribe(res => {
        this.channelRepository.updateTopicCommentCountForCreateComment(res.id, res.topic_id, res.parent_comment_id);
      });
      this.broadcaster.on<any>("LangUpdated").subscribe(res => {
        this.changeDetectorRef.detectChanges();
      });
    } else {
      this.commentService.on<any>(EVENTS.LOAD_REPLIES_COMMENT).pipe(takeUntil(this.isAlive$)).pipe(distinctUntilChanged()).subscribe(v => {
        this.loadReplies(v.comment, v.parent ? v.parent : null);
      });

      this.commentService.on<any>(EVENTS.SHOW_PREVIOUS_COMMENT).pipe(takeUntil(this.isAlive$)).subscribe(v => {
        if (!!v.comment) {
          this.loadPrevReplies(v.comment, v.parent ? v.parent : null);
        } else {
          this.loadPrevComments();
        }
      });

      this.commentService.on<any>(EVENTS.SHOW_NEXT_COMMENT).pipe(takeUntil(this.isAlive$)).subscribe(v => {
        if (!!v.comment) {
          this.loadNextReplies(v.comment, v.parent ? v.parent : null);
        } else {
          this.loadNextComments();
        }
      });

      this.broadcaster.on<any>(ConstantsUtil.ADD_COMMENT_IN_MENTIONED_COMMENT).pipe(takeUntil(this.isAlive$)).subscribe(res => {
        if (this.topicId + "" === res.topic_id + "") {
          this.addCommentInMentionedComments(res);
        }
      });

      this.broadcaster.on<any>(ConstantsUtil.UPDATE_COMMENT_IN_MENTIONED_COMMENT).pipe(takeUntil(this.isAlive$)).subscribe(res => {
        if (this.topicId + "" === res.topic_id + "") {
          this.updateCommentInMentionedComments(res);
        }
      });

      this.broadcaster.on<any>(ConstantsUtil.DELETE_COMMENT_IN_MENTIONED_COMMENT).pipe(takeUntil(this.isAlive$)).subscribe(res => {
        if (this.topicId + "" === res.topic_id + "") {
          this.deleteCommentInMentionedComments(res.commentId, res.parentId);
        }
      });

    }

    this.commonService.currentLanguage.pipe(distinctUntilChanged(), takeUntil(this.isAlive$)).subscribe(() => {
      const commentLabelKeys = Object.keys(this.commentLabelTranslations);
      this.translate.get(commentLabelKeys).pipe(take(1)).subscribe( translatedLabels => {
        this.commentLabelTranslations = translatedLabels;
      });
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.isMobile && this.isSocial) {
      this.isMobileScreen = true;
    }
    if (changes.topicId) {
      if (!!this.mentionedCommentId) {
        this.channelService.getCommentsWithMentionedComment(this.topicId, this.mentionedCommentId, this.topic?.is_iom ? this.topic?.channel_id : null ).pipe(take(1)).subscribe((v: any) => {
          if (v && !v.error) {
            const comments = CommonUtil.getNestedComments(v);
            this.level1_offset = v.level1_offset;
            this.level1_total_count = v.level1_total_count;
            this.childOffsets = CommonUtil.getChildOffsets(v);
            this.comments = comments;
            this.sortedComments = this.getSortedComment(this.comments);
            this.changeDetectorRef.markForCheck();
            setTimeout(() => {
              if (!this.isHideTextEditor) {
                this.scrollToMentionedComment();
              }
            }, 1000);
          }
        });
      } else {
        this.topicId = changes.topicId.currentValue;
        this.store.select(getAllComments).pipe(takeUntil(this.isAlive$))
          .subscribe(comments => {
            if (comments) {
              if (this.topicId === null) {
                return;
              }
              const topicComments = comments.filter(v => v.topic_id === parseInt(this.topicId.toString().replace("iom-", "")) && !v.parent_comment_id);
              this.broadcaster.broadcast(TOPIC_COMMENTS_LOADED);
              this.comments = topicComments;
              this.comments.map(c => {
                if (c.comments) {
                  c.comments = CommonUtil.getViewInlineImages(c.comments, 800, this.topic?.is_iom);
                }
              });
              this.sortedComments = this.getSortedComment(this.comments);
              this.changeDetectorRef.markForCheck();
            }
          });
        this.channelRepository
          .getCommentInfoByTopicId(this.topicId)
          .pipe(takeUntil(this.isAlive$))
          .subscribe((info) => {
            if (!info || (info && !info?.isLoaded)) {
              this.channelRepository
                .getTopicById(this.topicId)
                .pipe(takeUntil(this.isAlive$))
                .subscribe((v) => {
                  if (v) {
                    this.topic = v;
                    this.channelService
                      .getComments(
                        this.topicId,
                        this.topic?.is_iom ? this.topic?.channel_id : null
                      )
                      .pipe(takeUntil(this.isAlive$))
                      .subscribe((v: any) => {
                        if (v && !v.error) {
                        const comments = v.comments as CommentItem[];
                        const offset = v.offset + v.comments.length;
                        const total_count = v.total_count;
                        const topicId = this.topicId;
                        this.store.dispatch(
                          new TopicCommentsLoadSuccess({
                            topicId,
                            offset,
                            total_count
                          })
                        );
                        this.store.dispatch(
                          new CommentBulkAdd(
                            CommonUtil.getMappedComments(comments, this.topic?.is_iom)
                          )
                        );
                          }
                      });
                  }
                });
            }
          });
        this.changeDetectorRef.markForCheck();
      }
    }
    if (changes.comments) {
      this.sortedComments = this.getSortedComment(this.comments);
    }
  }

  ngOnDestroy() {
    this.isAlive$.next(false);
    this.isAlive$.complete();
  }

  onCommentFormClear() {
    this.onFormClear.next("");
    this.uploadedFiles = [];
    let element = this.elementRef.nativeElement?.querySelector(".topic-comments-list");
    if (element && element.click) {
      element.click();
    }
    this.changeDetectorRef.markForCheck();
  }

  handleCommentFileActions() {
    this.commentService.on(EVENTS.DOWNLOAD_ALL_FILES).pipe(takeUntil(this.isAlive$)).subscribe((value: { data: File[], commentId: CommentItem["id"] }) => {
      this.fileActionsService.downloadFilesAsZIP((value?.data || []), `comment-${value?.commentId || ""}.zip`);
    });
    this.commentService.on(EVENTS.DOWNLOAD_FILE).pipe(takeUntil(this.isAlive$)).subscribe((value: { data: File, commentId: CommentItem["id"] }) => {
      this.fileActionsService.downloadFile(value.data);
    });
    this.commentService.on(EVENTS.COPY_FILE_LINK).pipe(takeUntil(this.isAlive$)).subscribe((value: { data: File, commentId: CommentItem["id"] }) => {
      this.fileActionsService.copyFileLink(value.data);
    });
    this.commentService.on(EVENTS.FILE_ITEM_CLICKED).pipe(takeUntil(this.isAlive$)).subscribe((value: { data: File, comment: CommentItem }) => {
      this.channelRepository.showFilePreview(value?.comment?.attachments, value.data, false, value?.data?.is_iom);
    });
  }

  addComment(text: string, attachments: any[] = [], parentId?: number) {
    let element = this.elementRef.nativeElement?.querySelector(".topic-comments-list");
    if (element && element.click) {
      element.click();
    }
    // const textString = htmlToText(text.replace(/<img[^>]*>/g,""), {});
    if (this.isUploadRunning || !text) { return; }

    let inlineUploads = [];
    if (this.inlineUploads.length > 0) {
      let inlineUploadData = null;
      if (!!parentId) {
        inlineUploadData = this.inlineUploads.find(v => v.parentId === parentId);
      } else {
        inlineUploadData = this.inlineUploads.find(v => !v.parentId);
      }
      if (inlineUploadData?.uploads) {
        inlineUploads = [...inlineUploadData.uploads].map(v => ({...v, is_inline: true}));
      }
    }
    const uploads = [...attachments, ...inlineUploads];
    const body = {
      comments: text,
      parent_comment_id: parentId,
      uploads: { ...uploads }
    };
    const parser = new DOMParser();
    const htmlDoc = parser.parseFromString(text, "text/html");
    const users = htmlDoc.getElementsByClassName("mention");
    const userIds = Array.from(users).map( user => user.getAttribute("data-id"));

    this.channelService.addComment(body, this.topicId, this.topic?.is_iom ? this.topic?.channel_id : null).pipe(take(1)).subscribe((v: any) => {
      if (v && !v.error) {
        this.uploadedFiles = [];
        if (!!parentId) {
          this.inlineUploads = this.inlineUploads.filter(v => v.parentId !== parentId);
        } else {
          this.inlineUploads = this.inlineUploads.filter(v => !!v.parentId);
        }
        this.channelRepository.updateTopicCommentCount(this.topicId, 1, 0);
        // this.updateTopicCommentCount(1, "increase");
        if (v.comment) {
          const comment = CommonUtil.getMappedComments([v.comment], this.topic?.is_iom)[0] as CommentItem;
          if (this.isMobileScreen) {
            this.scrollToNewComment(comment.id);
          }
          this.channelRepository.addCommentIntoStore(comment);
          if (userIds?.length > 0) {
            const currentUrl = CommonUtil.getBaseOriginUrl();
            userIds?.forEach((jId) => {
              const uniqueSecretKey = MESSAGE_DECODER_SECRET_KEY.replace("{{ USERNAME }}", jId);
              this.conversationRepo.sendMessage({
                body: `${uniqueSecretKey}${TOPIC_MENTION_MESSAGE_RECEIVER} ${currentUrl}/talk/channels/${this.topic?.channel_id}/topics/${this.topicId}?commentId=${v.comment.id}`,
                type: "chat"
              }, jId, "chat");
            });
          }
        }
      }
    });
    let message = this.translate.get("COMMENT_ADDED").pipe(take(1)).subscribe(resp => {
      this.channelSnackBarService.openSnackBar(resp, SnackbarType.CHECKMARK);
    });
  }

  canAddComments() {
    return !CommonUtil.getPermission(this.topic?.permissions, "read_only");
  }
  cancelFileUpload(){
    this.cancelFileUploadVar = true;
    this.fileUploading = false;
  }
  canEnableDisableComments() {
    let userConfig = JSON.parse(localStorage.getItem("userConfigFromServer"));
    if (userConfig) {
      return this.topic.author.id === userConfig.id;
    }
    return false;
  }

  enableDisableComment(event: MouseEvent) {
    this.enableDisableComments.emit();
  }

  async getDeletedAttachment(commentId: number, newAttachments: any[] = [], parentId?: number): Promise<number[]> {
    const comment: CommentItem = await this.channelRepository.getComment(commentId, parentId, this.topicId).pipe(take(1)).toPromise();
    const oldAttachments = comment?.attachments || [];
    const newAttachmentIds = newAttachments.map(attachment => attachment?.id);
    const difference = oldAttachments.filter(attachment => !newAttachmentIds.includes(attachment.id)).map(attachment => attachment.id);
    return difference;
  }

  updateComment(commentId, text: string, attachments: any[] = [], parentId?: number) {
    let inlineUploads = [];
    if (this.inlineUploads.length > 0) {
      let inlineUploadData = null;
      if (!!parentId) {
        inlineUploadData = this.inlineUploads.find(v => v.parentId === parentId);
      } else {
        inlineUploadData = this.inlineUploads.find(v => !v.parentId);
      }
      if (inlineUploadData?.uploads) {
        inlineUploads = [...inlineUploadData.uploads].map(v => ({...v, is_inline: true}));
      }
    }
    let files = [...attachments, ...inlineUploads];
    const update = () => this.channelService.updateComment(text, commentId, {...files}, this.topic?.is_iom ? this.topic?.channel_id : null).pipe(take(1)).subscribe((v: any) => {
      if (v.comment) {
        const comment = CommonUtil.getMappedComments([v.comment], this.topic?.is_iom)[0] as CommentItem;
        !comment.replies.length ? delete comment.replies : noop();
        this.channelRepository.updateCommentIntoStore(comment);

        if (!!parentId) {
          this.inlineUploads = this.inlineUploads.filter(v => v.parentId !== parentId);
        } else {
          this.inlineUploads = this.inlineUploads.filter(v => !!v.parentId);
        }
      }
    });

    this.getDeletedAttachment(commentId, attachments, parentId).then(deletedAttachments => {
      if (deletedAttachments.length) {
        this.channelService.deleteBulkAttachment(deletedAttachments).pipe(take(1)).subscribe(() => update());
      } else {
        update();
      }
    });
  }

  likeComment(commentId, liked: boolean) {
    if (!!liked) {
      this.channelService.likeComment(commentId, this.topic?.is_iom ? this.topic?.channel_id : null).pipe(take(1)).subscribe((v: any) => {
        if (v.comment) {
          this.updateCommentInStore(v.comment);
        }
      });
    } else {
      this.channelService.unlikeComment(commentId, this.topic?.is_iom ? this.topic?.channel_id : null).pipe(take(1)).subscribe((v: any) => {
        if (v.comment) {
          this.updateCommentInStore(v.comment);
        }
      });
    }
  }

  async deleteComment(commentId: number, parentId?: number) {
    if (CommonUtil.isMobileSize()) {
     const dialogOpen = document.querySelector("vp-confirmation-channel");
     if (dialogOpen === null) {
      const options = {
        maxWidth: "90vw",
        maxHeight: "200px",
        width: "90vw",
        height: "200px"
      };
      const { ConfirmationChannelComponent } = await import(
        "../confirmation-channel/confirmation-channel.component");
      this.matDialog.open(ConfirmationChannelComponent, Object.assign({
        backdropClass: "vnctalk-form-backdrop",
        panelClass:["vnctalk-form-panel", "confirmation-dialog"],
        disableClose: true,
        data: {
          headerText: "DELETE_COMMENT",
          bodyText: "DELETE_COMMENT_CONFIRM_MSG",
          okLabel: "YES",
          cancelLabel: "NO"
        },
        autoFocus: true
      }, options)).afterClosed().pipe(take(1)).subscribe( (res: any) => {
        if (!!res && res.confirmation) {
            if (res.confirmation === "yes") {
              this.deleteCommentById(commentId, parentId);
            }
        }
      });
     }
    } else {
      this.deleteCommentById(commentId, parentId);
    }
  }

  deleteCommentById(commentId: number, parentId?: number): void {
    this.channelService.deleteComment(commentId, this.topic?.is_iom ? this.topic?.channel_id : null).pipe(take(1)).subscribe(() => {
      this.getCommentAndItsRepliesCount(commentId, parentId).then(() =>
        this.channelRepository.updateTopicCommentCount(this.topicId, -1, 0)
      // this.updateTopicCommentCount(count, 'decrease')
      );
      this.channelRepository.removeCommentIntoStore(commentId, parentId, this.topicId);
    });
  }

  loadRepliesComment(comment: CommentItem, parent?: CommentItem) {
    if (!parent) {
      parent = comment;
    }
    if ((comment?.replies && comment?.replies?.length === 0) || !comment?.replies) {
      this.channelService.getRepliesComments(this.topicId, comment.id, this.topic?.is_iom ? this.topic?.channel_id : null).pipe(take(1)).subscribe( (v: any) => {
        if (v && !v.error) {
          var comments = v.comments as CommentItem[];
          comments = this.updateCommentsDate(comments);
          const offset = v.offset + v.comments.length;
          const total_count = v.total_count;
          this.store.dispatch(new CommentRepliesLoadSuccess({commentId: comment.id, offset, total_count}));
          this.store.select(state => getParentCommentInTopicById(state, parent.id, this.topicId)).pipe(take(1)).subscribe(c => {
            if (!!c) {
              if (c.id === comment.id) {
                this.store.dispatch(new CommentUpdate({id: parent.id, replies: [...comments]}));
              } else {
                c.replies.forEach(c1 => {
                  // c1.created_on = this.getPublishDate("post", c.created_on);
                  if (c1.id === comment.id) {
                    c1.replies = [...comments];
                  }
                });
                this.store.dispatch(new CommentUpdate({id: parent.id, replies: c.replies}));
              }
              this.commentService.broadcast(EVENTS.REPLIES_LOADED, {comment: comment});
            }
          });
        }
      });
    }
  }

  loadMoreReplies(comment: CommentItem, parent?: CommentItem) {
    if (!parent) {
      parent = comment;
    }
    this.channelRepository.loadMoreReplies(this.topicId, comment, parent, this.topic?.is_iom ? this.topic?.channel_id : null);
  }

  loadPrevComments() {
    if (this.level1_offset !== 0) {
      const offset = this.level1_offset < 25 ? 0 : this.level1_offset - 25;
      const limit = this.level1_offset < 25 ? this.level1_offset : 25;
      this.channelService.getComments(this.topicId, this.topic?.is_iom ? this.topic?.channel_id : null, {offset: offset, limit: limit}).pipe(take(1)).subscribe((v: any) => {
        if (v && !v.error) {
          const comments = CommonUtil.getMappedCommentsForMention(v.comments) as CommentItem[];
          this.level1_offset = v.offset;
          this.level1_total_count = v.total_count;
          this.comments = [...CommonUtil.getMappedComments(comments, this.topic?.is_iom), ...this.comments];
          this.sortedComments = this.getSortedComment(this.comments);
          this.commentService.broadcast(EVENTS.MORE_COMMENTS_LOADED, {previous: true});
          this.changeDetectorRef.markForCheck();
        }
      });
    }
  }

  loadNextComments() {
    const offset     = this.level1_offset + this.comments.length;
    const totalCount = this.level1_total_count;
    if (offset < totalCount) {
      this.channelRepository.getTopicById(this.topicId).pipe(takeUntil(this.isAlive$))
      .subscribe(v => {
        this.topic = v;
        this.channelService.getComments(this.topicId, this.topic?.is_iom ? this.topic?.channel_id : null, {offset: offset, limit: 25}).pipe(take(1)).subscribe((v: any) => {
        if (v && !v.error) {
            const comments = CommonUtil.getMappedCommentsForMention(v.comments) as CommentItem[];
            this.comments  = [...this.comments, ...CommonUtil.getMappedComments(comments, this.topic?.is_iom)];
            this.sortedComments = this.getSortedComment(this.comments);
            this.commentService.broadcast(EVENTS.MORE_COMMENTS_LOADED, {previous: false});
            this.changeDetectorRef.markForCheck();
        }
        });
        this.changeDetectorRef.markForCheck();
      });
    }
  }

  loadReplies(comment: CommentItem, parent?: CommentItem) {
    this.channelService.getRepliesComments(this.topicId, comment.id, this.topic?.is_iom ? this.topic?.channel_id : null).pipe(debounceTime(500), take(1)).subscribe((v: any) => {
      if (v && !v.error) {
        const comments = CommonUtil.getMappedComments(CommonUtil.getMappedCommentsForMention(v.comments), this.topic?.is_iom) as CommentItem[];
        const offset = v.offset;
        const total_count = v.total_count;
        this.childOffsets[comment.id] = {offset, total_count};
        this.comments.forEach( c => {
          if (c.id === comment.id) {
            const replies = c.replies || [];
            c.replies = [...replies, ...comments];
            c.hasPrevious = offset > 0;
            c.hasNext = comments.length < total_count;
          } else if (!!parent && c.id === parent.id){
            c.replies?.forEach(c1 => {
              if (c1.id === comment.id) {
                const replies = c1.replies || [];
                c1.replies = [...replies, ...comments];
                c1.hasPrevious = offset > 0;
                c1.hasNext = comments.length < total_count;
              }
            });
          }
        });
        this.sortedComments = this.getSortedComment(this.comments);
        this.commentService.broadcast(EVENTS.REPLIES_LOADED, {comment});
        this.changeDetectorRef.markForCheck();
      }
    });
  }

  loadPrevReplies(comment: CommentItem, parent?: CommentItem) {
    const oldOffset = this.childOffsets[comment.id].offset;
    if ( oldOffset !== 0) {
      const offset = oldOffset < 25 ? 0 : oldOffset - 25;
      const limit = oldOffset < 25 ? oldOffset : 25;
      this.channelService.getRepliesComments(this.topicId, comment.id, this.topic?.is_iom ? this.topic?.channel_id : null, {offset: offset, limit: limit}).pipe(debounceTime(500), take(1)).subscribe((v: any) => {
        const comments = CommonUtil.getMappedComments(CommonUtil.getMappedCommentsForMention(v.comments), this.topic?.is_iom) as CommentItem[];
        const offset = v.offset;
        const total_count = v.total_count;
        this.childOffsets[comment.id] = {offset, total_count};
        this.comments.forEach( c => {
          if (c.id === comment.id) {
            const replies = c.replies || [];
            c.replies = [...comments, ...replies];
            c.hasPrevious = offset > 0;
            c.hasNext = c.replies.length < total_count;
          } else if (!!parent && c.id === parent.id) {
            c.replies?.forEach(c1 => {
              if (c1.id === comment.id) {
                const replies = c1.replies || [];
                c1.replies = [...comments, ...replies];
                c1.hasPrevious = offset > 0;
                c1.hasNext = c1.replies.length < total_count;
              }
            });
          }
        });
        this.sortedComments = this.getSortedComment(this.comments);
        this.commentService.broadcast(EVENTS.REPLIES_LOADED, {comment, previous: true});
        this.changeDetectorRef.markForCheck();
      });
    }
  }

  loadNextReplies(comment: CommentItem, parent?: CommentItem) {
    const childComments = comment.replies;
    const offset = this.childOffsets[comment.id].offset + childComments.length;
    const totalCount = this.childOffsets[comment.id].total_count;
    if (offset < totalCount) {
      this.channelService.getRepliesComments(this.topicId, comment.id, this.topic?.is_iom ? this.topic?.channel_id : null, {offset: offset, limit: 25}).pipe(debounceTime(500), take(1)).subscribe((v: any) => {
        if (v && !v.error) {
          const comments = CommonUtil.getMappedComments(CommonUtil.getMappedCommentsForMention(v.comments), this.topic?.is_iom) as CommentItem[];
          this.comments.forEach( c => {
            if (c.id === comment.id) {
              const replies = c.replies || [];
              c.replies = [...replies, ...comments];
              c.hasPrevious = this.childOffsets[comment.id].offset > 0;
              c.hasNext = c.replies.length + this.childOffsets[comment.id].offset < totalCount;
            } else if (!!parent && c.id === parent.id) {
              c.replies?.forEach(c1 => {
                if (c1.id === comment.id) {
                  const replies = c1.replies || [];
                  c1.replies = [...replies, ...comments];
                  c.hasPrevious = this.childOffsets[comment.id].offset > 0;
                  c.hasNext = c.replies.length + this.childOffsets[comment.id].offset < totalCount;
                }
              });
            }
          });
          this.sortedComments = this.getSortedComment(this.comments);
          this.commentService.broadcast(EVENTS.REPLIES_LOADED, {comment});
          this.changeDetectorRef.markForCheck();
        }
      });
    }
  }

  buildAvatarUrl(bare: string) {
    this.avatarUrl = this.avatarRepo.buildAvatarUrl(bare);
    this.changeDetectorRef.markForCheck();
  }

  onFileUpload(filesArray: any, triggerEvent = false) {
    if (!!filesArray?.length) {
      let files: any = [];
      for (let i = 0; i < filesArray.length; i++) {
        const file = filesArray[i];
        if (file) {
          let isFileExceedLimit = this.channelRepository.isFileSizeExceedLimit(file);
          if (isFileExceedLimit) {
            this.channelRepository.showFileExceedNotification(file);
          } else {
            files.push(file);
          }
        }
      }
      if (files.length > 5) {
        this.showNotification("FILE_UPLOAD_LIMIT");
        return;
      }
      if (this.isUploadRunning) {
        this.showNotification("FILE_UPLOAD_ALREADY_RUNNING_MSG");
        return;
      }
      this.readFiles(files).pipe(take(1)).subscribe(fileUploads => {
        this.isUploadRunning = true;
        if (triggerEvent) {
          this.commentService.broadcast(EVENTS.COMMENT_FILES_UPLOADED, { count: filesArray?.length, isComplete: false });
        } else {
          this.fileUploading = true;
          this.uploadFilesCount = filesArray.length;
        }
        this.changeDetectorRef.markForCheck();
        this.uploadFiles(fileUploads).pipe(take(1)).subscribe(response => {
          this.isUploadRunning = false;
          if (triggerEvent) {
            this.commentService.broadcast(EVENTS.COMMENT_FILES_UPLOADED, { files: CommonUtil.getMappedAttachments(response, this.topic?.is_iom), isComplete: true, count: 0 });
          } else {
            if (!this.cancelFileUploadVar) {
              this.uploadedFiles = [...this.uploadedFiles, ...CommonUtil.getMappedAttachments(response, this.topic?.is_iom)];
            }
            this.cancelFileUploadVar = false;
            this.uploadFilesCount = 0;
            this.fileUploading = false;
          }
          this.changeDetectorRef.markForCheck();
        });
      });
    }
  }

  onInlineFileUpload(filesArray: any, commentId?: number) {
    if (filesArray.name){ // when pasted
      filesArray = [filesArray];
    }
    if (!!filesArray?.length) {
      let files: any = [];
      for (let i = 0; i < filesArray.length; i++) {
        const file = filesArray[i];
        if (file) {
          let size = CommonUtil.bytesToMegaBytes(file?.size);
          if ( size > MAX_FILES_UPLOAD_SIZE_IN_MB ) {
            this.showNotification("FILE_SIZE_EXCEED", 5000, { filename: file?.name });
          } else {
            files.push(file);
          }
        }
      }
      if (files.length > 5) {
        this.showNotification("FILE_UPLOAD_LIMIT");
        return;
      }
      if (this.isUploadRunning) {
        this.showNotification("FILE_UPLOAD_ALREADY_RUNNING_MSG");
        return;
      }
      this.readFiles(files).pipe(take(1)).subscribe(fileUploads => {
        this.isUploadRunning = true;
        this.uploadFiles(fileUploads).pipe(take(1)).subscribe(response => {
          this.isUploadRunning = false;
          let index = -1;
          if (!!commentId) {
            index = this.inlineUploads.indexOf(v => v.parentId === commentId);
          } else {
            index = this.inlineUploads.indexOf(v => !v.parentId);
          }
          if (index === -1) {
            this.inlineUploads.push({
              parentId: commentId,
              uploads: response,
            });
          } else {
            const prevUploads = this.inlineUploads[index].uploads || [];
            this.inlineUploads[index].uploads = [...prevUploads, ...response];
          }
          this.commentService.broadcast(EVENTS.INLINE_IMAGE_UPLOADED, { files: CommonUtil.getMappedAttachments(response, this.topic?.is_iom), commentId });
        });
      });
    }
  }

  removeFileAttachment(file: any) {
    this.uploadedFiles = this.uploadedFiles.filter(uploadedFile => uploadedFile.id !== file?.id);
    this.changeDetectorRef.markForCheck();
    this.changeDetectorRef.detectChanges();
  }
  removeAllFileAttachment() {
    this.uploadedFiles = [];
    this.changeDetectorRef.markForCheck();
    this.changeDetectorRef.detectChanges();
  }
  getPermission(permissions: any[] | null = null, toCheck: string) {
    return CommonUtil.getPermission(permissions, toCheck);
  }

  removeFilesFromComment(comment: any) {
    if (!!comment) {
      if (this.getPermission(comment?.permissions, "editable")) {
        let ids = comment?.attachments?.map(attachment => {
          return attachment?.id;
        });
        this.channelService.deleteTopicAttachments(ids).pipe(take(1)).subscribe(resp => {
          this.channelService
            .getCommentsWithMentionedComment(
              this.topicId,
              this.mentionedCommentId,
              this.topic?.is_iom ? this.topic?.channel_id : null
            )
            .pipe(take(1))
            .subscribe((v: any) => {
              if (v && !v.error) {
                const comments = CommonUtil.getNestedComments(v);
                this.level1_offset = v.level1_offset;
                this.level1_total_count = v.level1_total_count;
                this.childOffsets = CommonUtil.getChildOffsets(v);
                this.comments = comments;
                this.sortedComments = this.getSortedComment(this.comments);
                this.changeDetectorRef.markForCheck();
              }
            });
        }, (err) => {
          this.translate.get("SOME_UNKNOWN_ERROR")
            .pipe(take(1))
            .subscribe(text => {
              this.channelSnackBarService.openSnackBar(text, SnackbarType.CLOSE);
            });
        });
      } else {
        this.translate.get("NOT_ALLOWED").pipe(take(1)).subscribe(text => {
          this.channelSnackBarService.openSnackBar(text, SnackbarType.CLOSE);
        });
      }
    }
  }

  removeFileFromComment(item: any) {
    if (!!item) {
      if (this.getPermission(item?.comment?.permissions, "editable")) {
        let id = item?.comment?.attachments?.map(attachment => {
              if (attachment?.id === item?.file?.id) {
                return attachment?.id;
              }
        });
        this.channelService.deleteTopicAttachments(id).pipe(take(1)).subscribe(resp => {
          this.channelService
            .getCommentsWithMentionedComment(
              this.topicId,
              this.mentionedCommentId,
              this.topic?.is_iom ? this.topic?.channel_id : null
            )
            .pipe(take(1))
            .subscribe((v: any) => {
              if (v && !v.error) {
                const comments = CommonUtil.getNestedComments(v);
                this.level1_offset = v.level1_offset;
                this.level1_total_count = v.level1_total_count;
                this.childOffsets = CommonUtil.getChildOffsets(v);
                this.comments = comments;
                this.sortedComments = this.getSortedComment(this.comments);
                this.changeDetectorRef.markForCheck();
              }
            });
        }, (err) => {
          this.translate.get("SOME_UNKNOWN_ERROR")
            .pipe(take(1))
            .subscribe(text => {
              this.channelSnackBarService.openSnackBar(text, SnackbarType.CLOSE);
            });
        });
      } else {
        this.translate.get("NOT_ALLOWED").pipe(take(1)).subscribe(text => {
          this.channelSnackBarService.openSnackBar(text, SnackbarType.CLOSE);
        });
      }
    }
  }

  private translateText(textString: string) {
    let transFormedText  = textString;
    this.translate.get(textString).pipe(take(1)).subscribe( t => {
      if (!!t) {
        transFormedText = t;
      }
    });
    return transFormedText;
  }

  private uploadFiles(fileUploadsArray: any[]): Observable<any> {
    const fileUploads: any = [];
    for (let i = 0; i < fileUploadsArray.length; i++) {
      fileUploads.push(
        this.channelService.uploadFile(fileUploadsArray[i].content, fileUploadsArray[i].filename, fileUploadsArray[i].content_type).pipe(
          map((res: any)  => res.upload),
          catchError((exp) => of(
            this.showNotification(exp.error?.errors[0]?.includes("exceeded") || exp.error?.errors[0]?.includes("überschritten") ? "STORAGE_QUOTA_EXCEED" : "FILE_UPLOAD_ERROR", 5000, { filename: fileUploadsArray[i].filename})
          ))
        )
      );
    }
    return forkJoin(fileUploads);
  }

  private readFiles(files: any[]): Observable<any> {

    const fileReaderObs = (file) => {
      let myReader: FileReader = new FileReader();
      let fileReaderObs = Observable.create((observer: any) => {
        myReader.onloadend = () => {
          let upload = {
            filename: file.name,
            content_type: file.type,
            content: myReader.result
          };
          observer.next(upload);
          observer.complete();
        };
      });
      myReader.readAsArrayBuffer(file);
      return fileReaderObs;
    };

    const observableUploadFilesBatch = [];
    for (let i = 0; i < files.length; i++) {
      observableUploadFilesBatch.push(fileReaderObs(files[i]));
    }
    return forkJoin(observableUploadFilesBatch);
  }

  private showNotification(message: string, ...additionalArgs) {
    this.translate.get(message, { filename: additionalArgs[1].filename }).pipe(take(1)).subscribe(text => {
      this.channelSnackBarService.openSnackBar(text, SnackbarType.CLOSE);
    });
  }

  private updateCommentInStore(comment: CommentItem) {
    const parentId = comment.parent_comment_id;
    if (!parentId) {
      this.store.dispatch(new CommentUpdate(comment));
    } else {
      this.store.select(state => getParentCommentInTopicById(state, parentId, this.topicId)).pipe(take(1)).subscribe(c => {
        if (!!c) {
          if (c.id === parentId) {
            let replies = c.replies || [];
            replies = replies.map(oldComment => {
              if (oldComment.id === comment.id) {
                return {...oldComment, ...comment};
              }
              return oldComment;
            });
            this.store.dispatch(new CommentUpdate({id: parentId, replies: replies}));
          } else {
            c.replies.forEach(c1 => {
              if (c1.id === parentId) {
                let replies = c1.replies || [];
                replies = replies.map(oldComment => {
                  if (oldComment.id === comment.id) {
                    return comment;
                  }
                  return oldComment;
                });
                c1.replies = replies;
              }
            });
            this.store.dispatch(new CommentUpdate({id: parentId, replies: c.replies}));
          }
        }
      });
    }
  }

  private getMentionUsers(topic: Topic): void {
    if (topic.is_private) {
      this.channelRepository.getMembersOfTopic(topic.id)
        .pipe(takeUntil(this.isAlive$))
        .subscribe((members: Member[]) => {
          this.usersForMentions = members
            .filter(v => v.jid !== this.conversationRepo.userJID.bare)
            .map(v => {
              return {id: v.jid, value: v.name, avatar_url: v.avatar_url, type: "user"};
            });
          this.changeDetectorRef.markForCheck();
        });
    } else {
      this.contactRepository.getContacts()[0].pipe(takeUntil(this.isAlive$)).subscribe(contacts => {
        this.usersForMentions = contacts
          .map(v => {
            const avatar_url = this.avatarRepo.buildAvatarUrl(v.bare);
            return {id: v.bare, value: v.name, avatar_url, type: "user"};
          });
        this.changeDetectorRef.markForCheck();
      });
    }
  }

  private async getCommentAndItsRepliesCount(commentId: CommentItem["id"], parentId?: CommentItem["id"]) {
    const comment: CommentItem = await this.channelRepository.getComment(commentId, parentId, this.topicId).pipe(take(1)).toPromise();
    const getCommentsCount = (comment: CommentItem) => {
      let count = 1;
      if (!comment?.replies?.length) { return count; }
      comment.replies.forEach(replyComment => {
        count += getCommentsCount(replyComment);
      });
      return count;
    };
    return getCommentsCount(comment);
  }


  private addCommentInMentionedComments(comment: CommentItem) {
    const comments = CommonUtil.getMappedComments(CommonUtil.getMappedCommentsForMention([comment]), this.topic?.is_iom) as CommentItem[];
    if (!comment.parent_comment_id) {
      this.comments  = [...this.comments, ...comments];
      this.sortedComments = this.getSortedComment(this.comments);
      this.commentService.broadcast(EVENTS.MORE_COMMENTS_LOADED, {previous: false});
      this.changeDetectorRef.markForCheck();
    } else {
      this.comments.forEach( (c: CommentItem) => {
        if (c.id === comment.parent_comment_id) {
          const replies = c.replies || [];
          const replies_count = c.replies_count || 0;
          if (replies.length > 0 || !c.replies_count) {
            c.replies = [...replies, ...comments];
          }
          c.replies_count = replies_count + 1;
          this.commentService.broadcast(EVENTS.REPLIES_LOADED, {c});
          this.changeDetectorRef.markForCheck();
        } else if (c.replies) {
          c.replies.forEach(r => {
            if (r.id === comment.parent_comment_id) {
              const replies = r.replies || [];
              const replies_count = r.replies_count || 0;
              if (replies.length > 0 || !r.replies_count) {
                r.replies = [...replies, ...comments];
              }
              r.replies_count = replies_count + 1;
              this.commentService.broadcast(EVENTS.REPLIES_LOADED, {r});
              this.changeDetectorRef.markForCheck();
            }
          });
        }
      });
      this.sortedComments = this.getSortedComment(this.comments);
      this.changeDetectorRef.markForCheck();
    }
  }

  private updateCommentInMentionedComments(comment: CommentItem) {
    if (!comment.parent_comment_id) {
      const index = [...this.comments].findIndex(c => c.id === comment.id);
      if (index !== -1) {
        let updatedComment = this.comments[index];
        updatedComment = {...updatedComment, ...comment};
        this.comments[index] = updatedComment;
        this.sortedComments = this.getSortedComment(this.comments);
      }
      this.changeDetectorRef.markForCheck();
    } else {
      this.comments.forEach( (c: CommentItem) => {
        if (c.id === comment.parent_comment_id) {
          const replies = c.replies || [];
          const index = [...replies].findIndex(com => com.id === comment.id);
          if (index !== -1) {
            let updatedComment = replies[index];
            updatedComment = {...updatedComment, ...comment};
            replies[index] = updatedComment;
            c.replies = replies;
            this.changeDetectorRef.markForCheck();
          }
        } else if (c.replies) {
          c.replies.forEach(r => {
            if (r.id === comment.parent_comment_id) {
              const replies = r.replies || [];
              const index = [...replies].findIndex(com => com.id === comment.id);
              if (index !== -1) {
                let updatedComment = replies[index];
                updatedComment = {...updatedComment, ...comment};
                replies[index] = updatedComment;
                r.replies = replies;
                this.changeDetectorRef.markForCheck();
              }
            }
          });
        }
      });
      this.sortedComments = this.getSortedComment(this.comments);
      this.changeDetectorRef.markForCheck();
    }
  }

  private deleteCommentInMentionedComments(commentId: CommentItem["id"], parentId?: CommentItem["id"]) {
    if (!parentId) {
      this.comments = [...this.comments].filter(c => c.id !== commentId);
      this.sortedComments = this.getSortedComment(this.comments);
      this.changeDetectorRef.markForCheck();
    } else {
      this.comments.forEach( (c: CommentItem) => {
        if (c.id === parentId) {
          const replies = c.replies || [];
          c.replies = replies.filter(r => r.id !== commentId);
          c.replies_count--;
          this.changeDetectorRef.markForCheck();
        } else if (c.replies) {
          c.replies.forEach(r => {
            if (r.id === parentId) {
              const replies = r.replies || [];
              r.replies     = replies.filter(r => r.id !== commentId);
              r.replies_count--;
              this.changeDetectorRef.markForCheck();
            }
          });
        }
      });
      this.sortedComments = this.getSortedComment(this.comments);
      this.changeDetectorRef.markForCheck();
    }
  }

  // private updateTopicCommentCount(comment_count: number, action: 'increase' | 'decrease', ) {
  //   this.channelRepository.updateTopicCommentCount(this.topicId, comment_count, action);
  // }

  // getMappedAttachments(attachments: CommentItem["attachments"] = []): any[] {
  //   return attachments.map(attachment => ({
  //     ...attachment,
  //     content_url: CommonUtil.getAttachmentLocalAPIURL(attachment?.content_url),
  //     thumbnail_url: CommonUtil.getAttachmentLocalAPIURL(attachment?.thumbnail_url)
  //   }));
  // }
  //
  // getMappedComments(comments: CommentItem[] = []) {
  //   return [...comments].map((comment: CommentItem) => ({
  //     ...comment,
  //     replies: comment?.replies ? this.getMappedComments(comment.replies) : [],
  //     attachments: comment?.attachments ? this.getMappedAttachments(comment.attachments) : [],
  //   }));
  // }

  deleteMobileComment(): void { }

  forwardMobileComment(): void {
    this.translate.get("UNDER_DEVELOPMENT")
      .pipe(take(1))
      .subscribe(text => {
        this.channelSnackBarService.openSnackBar(text, SnackbarType.CLOSE);
      });
  }

  async editMobileComment(ev: any) {
    if (this.isHideTextEditor) {
      this.broadcaster.broadcast("SOCIAL_BROWSER_EDIT_COMMENT", ev);
      return;
    }
    const commentText = ev.commentText;
    const attachments = ev.commentAttachments;
    const options = {
      maxWidth: "100%",
      maxHeight: "100%",
      width: "100vw",
      height: "100vh",
    };
    let msg: string = "";
    this.translate.get("EDIT_COMMENT").pipe(take(1)).subscribe((text: string) => {
      msg = text;
    });

    const { AddEditCommentComponent } = await import(
      "../add-edit-channel-comment/add-edit-channel-comment.component");
    const dlg =  this.matDialog.open(AddEditCommentComponent, Object.assign({
      backdropClass: "vnctalk-form-backdrop",
      panelClass: [ "vnctalk-form-panel"],
      disableClose: true,
      data: {
        commentText: commentText,
        attachments: attachments,
        title: msg
      },
      autoFocus: false
      }, options));
    dlg.afterClosed().pipe(take(1)).subscribe(res => {
    if (!!res) {
      const description = res.description;
      const uploadedFiles = res.uploadedFiles;
      this.updateComment(ev.comment.id, description, uploadedFiles);
    }
    });
  }

  async replyMobileComment(ev: any) {
    if (this.isHideTextEditor) {
      this.broadcaster.broadcast("SOCIAL_BROWSER_REPLY_COMMENT", ev);
      return;
    }
    const options = {
      maxWidth: "100%",
      maxHeight: "100%",
      width: "100vw",
      height: "100vh",
    };
    let msg: string = "";
    this.translate.get("REPLY_COMMENT").pipe(take(1)).subscribe((text: string) => {
      msg = text;
    });
    const { AddEditCommentComponent } = await import(
      "../add-edit-channel-comment/add-edit-channel-comment.component");
    const dlg =  this.matDialog.open(AddEditCommentComponent, Object.assign({
        backdropClass: "vnctalk-form-backdrop",
        panelClass: [ "vnctalk-form-panel"],
        disableClose: true,
        data: {
          title: msg
        },
        autoFocus: false
    }, options));
    dlg.afterClosed().pipe(take(1)).subscribe(res => {
      if (!!res) {
        const description = res.description;
        const uploadedFiles = res.uploadedFiles;
        this.addComment(description, uploadedFiles, ev.comment.id);
      }
    });
  }

  async addMobileComment() {
    if (this.isMobile && this.isSocial) {
      this.broadcaster.broadcast("SOCIAL_BROWSER_ADD_COMMENT");
      return;
    }
    const options = {
      maxWidth: "100%",
      maxHeight: "100%",
      width: "100vw",
      height: "100vh",
    };
    let msg: string = "";
    this.translate.get("NEW_COMMENT_LBL").pipe(take(1)).subscribe((text: string) => {
      msg = text;
    });
    const { AddEditCommentComponent } = await import(
      "../add-edit-channel-comment/add-edit-channel-comment.component");
    const dlg =  this.matDialog.open(AddEditCommentComponent, Object.assign({
        backdropClass: "vnctalk-form-backdrop",
        panelClass: [ "vnctalk-form-panel"],
        disableClose: true,
        data: {
          title: msg
        },
        autoFocus: false
    }, options));
    dlg.afterClosed().pipe(take(1)).subscribe(res => {
      if (!!res) {
        const description = res.description;
        const uploadedFiles = res.uploadedFiles;
        this.addComment(description, uploadedFiles);
      }
    });
  }

  getDateTimeInFormat(timestamp: any): string {
    if (!!timestamp) {
      const formatStr = this.datetimeService.getFormatString(this.lang);
      const time = format(new Date(timestamp), formatStr, {locale: this.lang === "de" ? de : enUS});
      return time;
    }
    return null;
  }

  getSortedComment(comments: CommentItem[]) {
    let sortedComments = comments || [];
    sortedComments = sortedComments.sort((a: CommentItem, b: CommentItem) => {
      const aDate = Date.parse(a?.created_on);
      const bDate = Date.parse(b?.created_on);
      if (aDate < bDate) {
        return 1;
      } else if (aDate > bDate) {
        return -1;
      }

      return 0;
    });
    return sortedComments.map(c => {
      return { ...c, created_on: this.getPublishDate("post", c.created_on) };
    });
  }

  getPublishDate(socialType = "post", toTransform): string {
    let value: string = "";
    if (toTransform !== null) {
      value += this.datePipe.transform(toTransform, this.settings.dateFormat) + " " + " " + this.datePipe.transform(toTransform, this.settings.timeFormat);
    }
    return value;
  }

  scrollToMentionedComment() {
    const selector = "comment-" + this.mentionedCommentId;
    const selectedComment = document.getElementById(selector);
    if (this.isMobileScreen) {
      const topicCommentSection = document.querySelector(".mobile-topic-detail-component");
      topicCommentSection.scrollTo({
        top: selectedComment.offsetTop,
        behavior: "smooth"
      });
    } else {
      selectedComment?.scrollIntoView({
        behavior: "smooth"
      });
    }
  }

  scrollToNewComment(id: number) {
    const selector = "comment-" + id;
    setTimeout(() => {
      const selectedComment = document.getElementById(selector);
      const topicCommentSection = document.querySelector(".mobile-topic-detail-component");
      topicCommentSection.scrollTo({
        top: selectedComment.offsetTop - 50,
        behavior: "smooth"
      });
    }, 2000);
  }

  suggestMentionOptions = async (searchTerm, mentionChar) => {
    if (mentionChar === "@channel") {
      if (searchTerm.length === 0) {
        return this.defaultChannelsForMentions;
      } else {
        const channels: any = await this.channelService.searchChannels(searchTerm).toPromise();
        this.channelsForMentions = channels?.channels.map(v => ({id: v?.id, topics_count: v?.topics_count, author_name: v?.author?.name, avatar_url: v?.avatar_url, value: v?.name, type: "channel"}));
        this.changeDetectorRef.markForCheck();
        return  [...this.channelsForMentions];
      }
    } else if (mentionChar === "@topic"){
      if (searchTerm.length === 0) {
        return this.defaultTopicsForMentions;
      } else {
        const topics: any = await this.channelService.searchTopicsWithSubject(searchTerm).toPromise();
        this.topicsForMentions = topics?.topics.map(v => ({
          id: v?.id,
          avatar_url: CommonUtil.getTopicAvatar(v),
          channel_name: v?.channel_name,
          author_name: v?.author?.name,
          value: v?.subject,
          type: "topic"
        }));
        this.changeDetectorRef.markForCheck();
        return  [...this.topicsForMentions];
      }
    } else if (mentionChar === "@") {
      if (searchTerm.length === 0) {
        return this.usersForMentions;
      } else {
        return  [...this.usersForMentions].filter(v => v.value.toLowerCase().includes(searchTerm.toLowerCase()));
      }
    } else {
      if (searchTerm.length === 0) {
        return [...this.defaultTagsForMention];
      } else {
        let params: any = [];
        params["name"] = "~" + searchTerm;
        const tags = await this.conversationRepo.getTags(params).toPromise();
        this.tagsForMention = tags.map(v => ({id: v.id, value: v.name, type: "tag"}));
        this.changeDetectorRef.markForCheck();
        return  [...this.tagsForMention];
      }
    }
  };

  onCommentClick(event: any) {
    let tagId = "", tagName = "";

    if (event.target?.parentNode?.parentNode?.dataset?.denotationChar === "#") {
      tagId = event.target?.parentNode?.parentNode?.dataset?.id;
      tagName = event.target?.parentNode?.parentNode?.dataset?.value;
    } else if (event.target?.parentNode?.dataset?.denotationChar === "#") {
      tagId = event.target?.parentNode?.dataset?.id;
      tagName = event.target?.parentNode?.dataset?.value;
    } else if (event.target?.dataset?.denotationChar === "#") {
      tagId = event.target?.dataset?.id;
      tagName = event.target?.dataset?.value;
    } else {
      return;
    }

    this.broadcaster.broadcast(ConstantsUtil.INITIATE_TAG_BASED_SEARCH, {tagId, tagName});
  }
}
const HASH_TAG = `<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12">
    <defs>
        <filter id="ax0nlj596a" width="149.3%" height="143.9%" x="-24.6%" y="-22%" filterUnits="objectBoundingBox">
            <feOffset dy="8" in="SourceAlpha" result="shadowOffsetOuter1"/>
            <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="8"/>
            <feColorMatrix in="shadowBlurOuter1" result="shadowMatrixOuter1" values="0 0 0 0 0.031372549 0 0 0 0 0.176470588 0 0 0 0 0.239215686 0 0 0 0.2 0"/>
            <feOffset dy="4" in="SourceAlpha" result="shadowOffsetOuter2"/>
            <feGaussianBlur in="shadowOffsetOuter2" result="shadowBlurOuter2" stdDeviation="6"/>
            <feColorMatrix in="shadowBlurOuter2" result="shadowMatrixOuter2" values="0 0 0 0 0.0311856736 0 0 0 0 0.177658465 0 0 0 0 0.240432518 0 0 0 0.1 0"/>
            <feMerge>
                <feMergeNode in="shadowMatrixOuter1"/>
                <feMergeNode in="shadowMatrixOuter2"/>
                <feMergeNode in="SourceGraphic"/>
            </feMerge>
        </filter>
    </defs>
    <g fill="none" fill-rule="evenodd">
        <g fill="#8B96A0">
            <g filter="url(#ax0nlj596a)" transform="translate(-1015.000000, -804.000000) translate(943.000000, 754.000000)">
                <g>
                    <g>
                        <g>
                            <path d="M5.56 2.492L5.294 4h2l.266-1.508c.05-.284.297-.492.587-.492.231 0 .419.188.419.42 0 .024-.002.048-.006.072L8.293 4h1.405c.235 0 .426.19.426.426 0 .025-.002.05-.007.074-.05.29-.302.5-.596.5H8.117l-.353 2h1.404c.236 0 .426.19.426.426 0 .025-.002.05-.006.074-.051.29-.303.5-.596.5H7.587l-.266 1.508c-.05.284-.297.492-.587.492-.231 0-.419-.188-.419-.42 0-.024.002-.048.006-.072L6.588 8h-2L4.32 9.508c-.05.284-.297.492-.586.492-.232 0-.42-.188-.42-.42 0-.024.002-.048.006-.072L3.587 8h-1.58c-.235 0-.425-.19-.425-.426 0-.025.002-.05.006-.074.05-.29.302-.5.596-.5h1.58l.353-2h-1.58c-.236 0-.426-.19-.426-.426 0-.025.002-.05.006-.074.051-.29.303-.5.596-.5h1.58l.267-1.508c.05-.284.297-.492.587-.492.231 0 .419.188.419.42 0 .024-.002.048-.006.072zM7.117 5h-2l-.353 2h2l.353-2z" transform="translate(0.000000, 8.000000) translate(72.000000, 40.000000) translate(0.000000, 2.000000)"/>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </g>
</svg>
`;
const PROFILE_ICON = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="12px" height="12px" viewBox="0 0 12 12" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>66CE5F40-F711-4BF1-AB65-83E77152B42A</title>
    <defs>
        <filter x="-24.6%" y="-22.0%" width="149.3%" height="143.9%" filterUnits="objectBoundingBox" id="filter-1">
            <feOffset dx="0" dy="8" in="SourceAlpha" result="shadowOffsetOuter1"></feOffset>
            <feGaussianBlur stdDeviation="8" in="shadowOffsetOuter1" result="shadowBlurOuter1"></feGaussianBlur>
            <feColorMatrix values="0 0 0 0 0.031372549   0 0 0 0 0.176470588   0 0 0 0 0.239215686  0 0 0 0.2 0" type="matrix" in="shadowBlurOuter1" result="shadowMatrixOuter1"></feColorMatrix>
            <feOffset dx="0" dy="4" in="SourceAlpha" result="shadowOffsetOuter2"></feOffset>
            <feGaussianBlur stdDeviation="6" in="shadowOffsetOuter2" result="shadowBlurOuter2"></feGaussianBlur>
            <feColorMatrix values="0 0 0 0 0.0311856736   0 0 0 0 0.177658465   0 0 0 0 0.240432518  0 0 0 0.1 0" type="matrix" in="shadowBlurOuter2" result="shadowMatrixOuter2"></feColorMatrix>
            <feMerge>
                <feMergeNode in="shadowMatrixOuter1"></feMergeNode>
                <feMergeNode in="shadowMatrixOuter2"></feMergeNode>
                <feMergeNode in="SourceGraphic"></feMergeNode>
            </feMerge>
        </filter>
    </defs>
    <g id="Channels" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="0230.-Channels--New-Topic-#04" transform="translate(-1129.000000, -804.000000)" fill="#8B96A0">
            <g id="Group-13" transform="translate(943.000000, 754.000000)" filter="url(#filter-1)">
                <g id="Dropdown/item/@xl/related-topic" transform="translate(0.000000, 8.000000)">
                    <g id="Group-2" transform="translate(72.000000, 40.000000)">
                        <g id="Icon/product/profile-new" transform="translate(114.000000, 2.000000)">
                            <path d="M6.82179096,10.9327905 L6.79842481,10.9365052 L6.79842481,10.9365052 L6.731,10.945 L6.64340095,10.9589872 L6.64340095,10.9589872 L6.591,10.964 L6.60460405,10.9638172 C6.56343733,10.9687791 6.52211661,10.9732408 6.48064815,10.9771959 L6.489,10.975 L6.43141914,10.981647 C6.38347092,10.9857448 6.33532956,10.9891658 6.28700466,10.9919006 L6.26998795,10.9928234 L6.26998795,10.9928234 C6.24764395,10.9939976 6.23227579,10.9947238 6.21688962,10.9953805 L6,11 L6,11 L5.78311038,10.9953805 L5.78311038,10.9953805 L5.7370062,10.9932022 L5.7370062,10.9932022 L5.72991171,10.9928181 L5.69700485,10.9909703 C5.65404849,10.9884026 5.61123825,10.9852926 5.56858086,10.981647 L5.51,10.975 C5.47788339,10.9732408 5.43656267,10.9687791 5.39539595,10.9638172 L5.408,10.964 L5.35659905,10.9589872 L5.35659905,10.9589872 L5.268,10.945 L5.20128392,10.9364582 L5.20128392,10.9364582 L5.17820904,10.9327905 C5.1679129,10.931088 5.15762737,10.929354 5.14735256,10.9275886 L5.018,10.902 L4.94347474,10.8880106 L4.94347474,10.8880106 L4.889,10.875 L4.941029,10.8876389 C4.91760421,10.8825876 4.89424046,10.8773722 4.87093902,10.8719939 L4.889,10.875 L4.73781596,10.8393257 L4.73781596,10.8393257 L4.69555398,10.8281349 L4.69555398,10.8281349 L4.69048892,10.8265381 L4.66,10.817 L4.53790107,10.7828366 L4.53790107,10.7828366 L4.478,10.763 C4.13091519,10.6541179 3.79168481,10.5022042 3.47474311,10.3163799 L3.488,10.323 L3.4181786,10.2827133 L3.4181786,10.2827133 L3.24660367,10.1742457 C3.07739697,10.0624093 2.91538877,9.94056034 2.76142328,9.80954298 L2.709,9.763 L2.69091902,9.74741597 L2.69091902,9.74741597 L2.669,9.727 L2.61016998,9.67550076 C2.15848593,9.25871439 1.78380316,8.75972043 1.50987368,8.20227086 L1.496,8.173 L1.48764106,8.15535177 L1.48764106,8.15535177 L1.472,8.122 L1.48818108,8.15756393 C1.46956777,8.11871068 1.45144155,8.07957964 1.43381033,8.04017872 L1.389,7.936 L1.37696393,7.9070443 L1.37696393,7.9070443 L1.37,7.891 L1.35391906,7.85128388 C1.27780308,7.6604273 1.21310674,7.46377927 1.16067429,7.26218404 L1.137,7.163 L1.12663025,7.12237818 L1.12663025,7.12237818 L1.12,7.091 L1.11236106,7.058971 C1.09764015,6.99070448 1.08431316,6.92191954 1.07241137,6.85264744 L1.07189326,6.84905514 L1.065,6.804 L1.0410128,6.64340095 L1.0410128,6.64340095 L1.037,6.605 L1.03224756,6.57058838 L1.03224756,6.57058838 L1.029,6.532 L1.01835298,6.43141914 L1.01835298,6.43141914 L1.011,6.319 C1.00965693,6.31331525 1.00955432,6.31165111 1.00945252,6.30998675 L1.00813564,6.28742198 L1.00813564,6.28742198 L1.008,6.27 L1.00461951,6.21688962 C1.00155026,6.14497601 1,6.07266905 1,6 C1,3.23857625 3.23857625,1 6,1 C6.29067618,1 6.57555904,1.02480417 6.85264744,1.07241137 L7.058971,1.11236106 C7.46857014,1.20068652 7.85950608,1.33919315 8.22502499,1.52112709 L8.40563508,1.61568174 L8.40563508,1.61568174 L8.5818214,1.71728667 C9.21949833,2.10253428 9.76417894,2.62617911 10.1742457,3.24660367 L10.2827133,3.4181786 L10.2827133,3.4181786 L10.3843183,3.59436492 C10.4170219,3.65384141 10.4485506,3.7140552 10.4788729,3.77497501 L10.478,3.775 L10.5661897,3.95982128 C10.5940681,4.02212189 10.6207089,4.08509726 10.6460809,4.14871612 L10.7183591,4.34147192 C10.8779803,4.79559398 10.9738957,5.27971509 10.9953805,5.78311038 L11,6 C11,6.07266905 10.9984497,6.14497601 10.9953805,6.21688962 L10.992,6.269 L10.988,6.319 L10.981647,6.43141914 L10.981647,6.43141914 L10.973,6.505 L10.962,6.606 L10.9589872,6.64340095 L10.9589872,6.64340095 L10.927,6.849 C10.9156868,6.92191954 10.9023598,6.99070448 10.8876389,7.058971 L10.88,7.089 L10.86,7.173 L10.8393257,7.26218404 L10.8393257,7.26218404 L10.811,7.359 L10.7828366,7.46209893 C10.7644146,7.52243633 10.7448822,7.58228918 10.7242632,7.64163366 L10.72,7.651 C10.6955561,7.72340266 10.6714529,7.78766502 10.6460809,7.85128388 L10.624,7.902 L10.622,7.908 L10.5811148,8.00649084 C10.5655037,8.04208266 10.5494899,8.07745778 10.5330792,8.11261043 L10.531,8.113 L10.527,8.122 L10.5113812,8.15735488 L10.5113812,8.15735488 L10.502,8.174 L10.4788729,8.22502499 C10.4182283,8.34686462 10.3527584,8.46588014 10.2827133,8.5818214 L10.264,8.61 L10.251,8.631 L10.1742457,8.75339633 C9.98785174,9.03540749 9.77364497,9.29742284 9.53553391,9.53553391 L9.492,9.576 L9.38983002,9.67550076 L9.38983002,9.67550076 L9.332,9.726 L9.28220307,9.77198629 L9.28220307,9.77198629 L9.285,9.768 L9.23857672,9.80954298 L9.23857672,9.80954298 L9.145,9.885 L9.09411718,9.92791484 L9.09411718,9.92791484 L9.104,9.919 L9.08196159,9.93747295 C8.97580593,10.0206805 8.86620079,10.0996881 8.75339633,10.1742457 L8.705,10.204 L8.704,10.205 L8.5818214,10.2827133 L8.5818214,10.2827133 L8.523,10.316 L8.53521519,10.3105258 L8.53521519,10.3105258 L8.458,10.353 L8.40563508,10.3843183 L8.40563508,10.3843183 L8.309,10.434 L8.23719953,10.4727924 L8.23719953,10.4727924 L8.22502499,10.4788729 C8.10318535,10.5395176 7.9785216,10.5953369 7.85128388,10.6460809 L7.803,10.664 L7.76885111,10.6781083 L7.76885111,10.6781083 L7.785,10.671 L7.65852808,10.7183591 C7.62940072,10.7285972 7.60014994,10.7385732 7.57077858,10.7482843 L7.55676348,10.7525866 L7.55676348,10.7525866 L7.53,10.76 L7.5547459,10.753555 C7.54438376,10.756942 7.53400671,10.760296 7.52361489,10.763617 L7.53,10.76 L7.46209893,10.7828366 L7.46209893,10.7828366 L7.336,10.818 L7.30904562,10.8266653 L7.30904562,10.8266653 L7.30444602,10.8281349 L7.26218404,10.8393257 L7.26218404,10.8393257 L7.11,10.875 L7.12906098,10.8719939 C7.10575954,10.8773722 7.08239579,10.8825876 7.058971,10.8876389 L7.11,10.875 L7.05614452,10.8880931 L7.05614452,10.8880931 L6.981,10.902 L6.85264744,10.9275886 C6.84237263,10.929354 6.8320871,10.931088 6.82179096,10.9327905 Z M6,7.506 L5.81499011,7.51188446 L5.62544016,7.52304712 C4.75160418,7.58688888 4.02783193,7.81510618 3.44731543,8.20287307 C3.25633338,8.33044311 3.0955739,8.46438654 2.96379177,8.60498026 C3.69864199,9.45934184 4.78618225,10 6,10 C7.21428263,10 8.30219104,9.45892763 9.03578087,8.60472723 C8.95380495,8.51746633 8.86200063,8.43367584 8.75902203,8.35240639 L8.75902203,8.35240639 L8.65915617,8.27691909 L8.55268457,8.20287307 L8.42609301,8.12222401 C7.82507666,7.75727454 7.08031829,7.55221937 6.18500989,7.51188446 L6.18500989,7.51188446 L6,7.506 Z M6,2 C3.790861,2 2,3.790861 2,6 C2,6.62958868 2.14545532,7.22520444 2.40459428,7.75507561 C2.54987376,7.61855359 2.71253887,7.49110766 2.89186586,7.37132284 C3.67645747,6.84724016 4.64065125,6.56301387 5.77597476,6.51263814 L5.77597476,6.51263814 L6.00914872,6.50593166 L6.22402524,6.51263814 C7.35934875,6.56301387 8.32354253,6.84724016 9.10813414,7.37132284 C9.28744142,7.4910945 9.45009049,7.61852558 9.59569213,7.75354944 C9.85454468,7.22520444 10,6.62958868 10,6 C10,3.790861 8.209139,2 6,2 Z M6,2.5 C7.10614237,2.5 8,3.39385763 8,4.5 C8,5.60614237 7.10614237,6.5 6,6.5 C4.89385763,6.5 4,5.60614237 4,4.5 C4,3.39385763 4.89385763,2.5 6,2.5 Z M6,3.5 C5.44614237,3.5 5,3.94614237 5,4.5 C5,5.05385763 5.44614237,5.5 6,5.5 C6.55385763,5.5 7,5.05385763 7,4.5 C7,3.94614237 6.55385763,3.5 6,3.5 Z" id="Combined-Shape"></path>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </g>
</svg>`;
const TOPIC_PHOTO_ICON = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
    <defs>
        <filter id="gtrl6wbpca" width="149.3%" height="143.9%" x="-24.6%" y="-22%" filterUnits="objectBoundingBox">
            <feOffset dy="8" in="SourceAlpha" result="shadowOffsetOuter1"/>
            <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="8"/>
            <feColorMatrix in="shadowBlurOuter1" result="shadowMatrixOuter1" values="0 0 0 0 0.031372549 0 0 0 0 0.176470588 0 0 0 0 0.239215686 0 0 0 0.2 0"/>
            <feOffset dy="4" in="SourceAlpha" result="shadowOffsetOuter2"/>
            <feGaussianBlur in="shadowOffsetOuter2" result="shadowBlurOuter2" stdDeviation="6"/>
            <feColorMatrix in="shadowBlurOuter2" result="shadowMatrixOuter2" values="0 0 0 0 0.0311856736 0 0 0 0 0.177658465 0 0 0 0 0.240432518 0 0 0 0.1 0"/>
            <feMerge>
                <feMergeNode in="shadowMatrixOuter1"/>
                <feMergeNode in="shadowMatrixOuter2"/>
                <feMergeNode in="SourceGraphic"/>
            </feMerge>
        </filter>
    </defs>
    <g fill="none" fill-rule="evenodd">
        <g fill="#000">
            <g filter="url(#gtrl6wbpca)" transform="translate(-1015.000000, -770.000000) translate(943.000000, 754.000000)">
                <g>
                    <g>
                        <path d="M12.667 2.333c1.104 0 2 .896 2 2v8c0 1.105-.896 2-2 2H3.333c-1.104 0-2-.895-2-2v-8c0-1.104.896-2 2-2zM10.08 8.504l-2.25 3.044c-.207.279-.589.35-.88.176l-.065-.045-1.609-1.243-2.02 2.558.076.006h9.334c.029 0 .058-.002.086-.006l-2.672-4.49zm2.586-4.837H3.333c-.368 0-.666.298-.666.666v7.262L4.663 9.09c.212-.255.575-.313.853-.147l.067.046 1.579 1.22 2.419-3.271c.26-.351.773-.358 1.044-.035l.051.07 2.656 4.405V4.333c0-.334-.246-.611-.568-.66l-.098-.006z" transform="translate(0.000000, 8.000000) translate(72.000000, 8.000000)"/>
                    </g>
                </g>
            </g>
        </g>
    </g>
</svg>
`;
